import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'
import type { TypeParams } from '../types'

import { Api } from './api.service'

/** Survey admins collection, listing who administers the current survey. */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const meFeature = ngCore.inject(me.Feature)

    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: surveyAdmin => surveyAdmin.id,
      name: ec.Name.Predefined.SpaceSurveyAdmin,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: { id } }) => {
              // Only platform admins and tenant admins manage survey admins.
              const canManageUsers =
                meFeature.contexts.selectors.currentUserCanManageUsers.asSignal()

              return {
                iconsConfigs: canManageUsers
                  ? [
                      {
                        class: 'atn-icon atn-trash atn-red',
                        onClick: () =>
                          collection.plugins.editingPlugin.feature.actions.markForDeletion
                            .from(`Table.Row-${id}.Icons.Trash.Clicked`)
                            .dispatch({ id }),
                      },
                    ]
                  : [],
              }
            },
          })),
        ],
      },
    })
  }
}
